function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.135 11a9.866 9.866 0 1019.732 0A9.866 9.866 0 001.135 11h0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.619 14.549a.427.427 0 01-.621-.384V7.833a.43.43 0 01.621-.384l6.332 3.167a.427.427 0 010 .767L8.62 14.549z"
}));

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgPlay;